import Vue from 'vue';

// Estado das superfícies do push (hoje, o pedido de permissão) num observable
// de módulo — mesmo padrão do services/download/downloadSheets:
// o host <PushSheets /> é montado UMA vez em layout/Index.vue, irmão do
// <router-view>, e qualquer código abre por aqui.
export const pushSheets = Vue.observable({
  permission: {
    visible: false,
    // 'comment' | 'lesson' — muda título e texto.
    trigger: null,
    // SO negou de vez: o CTA vira "Ativar nos Ajustes".
    denied: false
  }
});

let permissionResolver = null;

// -> 'accept' | 'decline' | null (fechou sem decidir: toque fora/handle)
export function askPushPermission ({ trigger, denied }) {
  if (permissionResolver) {
    const stale = permissionResolver;
    permissionResolver = null;
    stale(null);
  }
  Object.assign(pushSheets.permission, { trigger: trigger || null, denied: Boolean(denied), visible: true });
  return new Promise(resolve => { permissionResolver = resolve; });
}

export function resolvePushPermission (choice) {
  pushSheets.permission.visible = false;
  const resolve = permissionResolver;
  permissionResolver = null;
  if (resolve) resolve(choice || null);
}
